import { useEffect, useState } from 'react';

// ── Icons ───────────────────────────────────────────────────────────────────
const CalendarIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
        <line x1="16" y1="2" x2="16" y2="6"/>
        <line x1="8" y1="2" x2="8" y2="6"/>
        <line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
);

const UserIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
    </svg>
);

const ArrowLeftIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="19" y1="12" x2="5" y2="12"/>
        <polyline points="12 19 5 12 12 5"/>
    </svg>
);

const ClockIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <polyline points="12 6 12 12 16 14"/>
    </svg>
);

const TagIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
        <line x1="7" y1="7" x2="7.01" y2="7"/>
    </svg>
);

const ShareIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="18" cy="5" r="3"/>
        <circle cx="6" cy="12" r="3"/>
        <circle cx="18" cy="19" r="3"/>
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
    </svg>
);

const FacebookIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
);

const TwitterIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
    </svg>
);

const LinkedInIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
);

// ── Format date helper ─────────────────────────────────────────────────────
const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

// ── Calculate read time ────────────────────────────────────────────────────
const calculateReadTime = (content) => {
    if (!content) return 1;
    const wordsPerMinute = 200;
    const text = content.replace(/<[^>]*>/g, '');
    const words = text.trim().split(/\s+/).length;
    return Math.ceil(words / wordsPerMinute);
};

// ── BlogPostDetail Component ───────────────────────────────────────────────
const BlogPostDetail = ({ postId, onBack, primaryColor = '#ff0037', blogSettings = {} }) => {
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [relatedPosts, setRelatedPosts] = useState([]);

    // Fetch post data
    useEffect(() => {
        const fetchPost = async () => {
            if (!postId) {
                setError('No post ID provided');
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                const response = await fetch(`?rest_route=/wp/v2/posts/${postId}&_embed=wp:featuredmedia,wp:term`);
                
                if (!response.ok) {
                    throw new Error('Failed to fetch post');
                }

                const data = await response.json();
                setPost(data);

                // Fetch related posts (same category, excluding current)
                const categories = data.categories?.join(',') || '';
                if (categories) {
                    const relatedResponse = await fetch(
                        `?rest_route=/wp/v2/posts&categories=${categories}&exclude=${postId}&per_page=3&_embed=wp:featuredmedia`
                    );
                    if (relatedResponse.ok) {
                        const relatedData = await relatedResponse.json();
                        setRelatedPosts(relatedData);
                    }
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPost();
        
        // Scroll to top when post loads
        const layout = document.querySelector('.gmfSiteLayout');
        if (layout) layout.scrollTo({ top: 0, behavior: 'smooth' });
    }, [postId]);

    // Handle share
    const handleShare = (platform) => {
        const url = encodeURIComponent(window.location.href);
        const title = encodeURIComponent(post?.title?.rendered || '');
        
        let shareUrl = '';
        switch (platform) {
            case 'facebook':
                shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
                break;
            case 'twitter':
                shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
                break;
            case 'linkedin':
                shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
                break;
            default:
                // Copy to clipboard
                navigator.clipboard.writeText(window.location.href);
                return;
        }
        
        window.open(shareUrl, '_blank', 'width=600,height=400');
    };

    // Loading state
    if (loading) {
        return (
            <div className="gmf-blog-detail-wrapper">
                <div className="gmf-blog-detail-container">
                    <div className="gmf-blog-detail-loading">
                        <div className="gmf-blog-detail-spinner" style={{ borderTopColor: primaryColor }}></div>
                        <p>Loading article...</p>
                    </div>
                </div>
            </div>
        );
    }

    // Error state
    if (error || !post) {
        return (
            <div className="gmf-blog-detail-wrapper">
                <div className="gmf-blog-detail-container">
                    <div className="gmf-blog-detail-error">
                        <h2>Article Not Found</h2>
                        <p>{error || 'The requested article could not be loaded.'}</p>
                        <button 
                            className="gmf-blog-detail-back-btn"
                            onClick={onBack}
                            style={{ background: primaryColor }}
                        >
                            <ArrowLeftIcon /> Go Back
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const featuredImage = post._embedded?.['wp:featuredmedia']?.[0]?.source_url || blogSettings.defaultFeaturedImage || '';
    const author = post._embedded?.author?.[0]?.name || blogSettings.defaultAuthor || 'GMF Securities';
    const date = formatDate(post.date);
    const readTime = calculateReadTime(post.content?.rendered);
    const categories = post._embedded?.['wp:term']?.find(terms => terms[0]?.taxonomy === 'category') || [];
    const tags = post._embedded?.['wp:term']?.find(terms => terms[0]?.taxonomy === 'post_tag') || [];

    return (
        <div className="gmf-blog-detail-wrapper">
            {/* Breadcrumb */}
            <div className="gmf-blog-detail-breadcrumb">
                <span className="gmf-blog-detail-breadcrumb-home" onClick={onBack}>Home</span>
                <span className="gmf-blog-detail-breadcrumb-sep">/</span>
                <span className="gmf-blog-detail-breadcrumb-current">
                    {post.title?.rendered?.replace(/<[^>]*>/g, '') || 'Article'}
                </span>
            </div>

            <article className="gmf-blog-detail-container">
                {/* Article Header */}
                <header className="gmf-blog-detail-header">
                    {categories.length > 0 && (
                        <div className="gmf-blog-detail-categories">
                            {categories.map((cat, idx) => (
                                <span 
                                    key={cat.id || idx} 
                                    className="gmf-blog-detail-category"
                                    style={{ background: primaryColor }}
                                >
                                    {cat.name}
                                </span>
                            ))}
                        </div>
                    )}
                    
                    <h1 
                        className="gmf-blog-detail-title"
                        dangerouslySetInnerHTML={{ __html: post.title?.rendered || 'Untitled' }}
                    />
                    
                    <div className="gmf-blog-detail-meta">
                        <span className="gmf-blog-detail-meta-item">
                            <UserIcon /> {author}
                        </span>
                        <span className="gmf-blog-detail-meta-item">
                            <CalendarIcon /> {date}
                        </span>
                        <span className="gmf-blog-detail-meta-item">
                            <ClockIcon /> {readTime} min read
                        </span>
                    </div>
                </header>

                {/* Featured Image */}
                {featuredImage && (
                    <div className="gmf-blog-detail-featured-image">
                        <img 
                            src={featuredImage} 
                            alt={post.title?.rendered?.replace(/<[^>]*>/g, '') || ''}
                            referrerPolicy="no-referrer"
                        />
                    </div>
                )}

                {/* Article Content */}
                <div 
                    className="gmf-blog-detail-content"
                    dangerouslySetInnerHTML={{ __html: post.content?.rendered || '' }}
                />

                {/* Article Footer */}
                <footer className="gmf-blog-detail-footer">
                    {/* Tags */}
                    {tags.length > 0 && (
                        <div className="gmf-blog-detail-tags">
                            <span className="gmf-blog-detail-tags-label">
                                <TagIcon /> Tags:
                            </span>
                            {tags.map((tag, idx) => (
                                <span key={tag.id || idx} className="gmf-blog-detail-tag">
                                    {tag.name}
                                </span>
                            ))}
                        </div>
                    )}

                    {/* Share Buttons */}
                    <div className="gmf-blog-detail-share">
                        <span className="gmf-blog-detail-share-label">
                            <ShareIcon /> Share:
                        </span>
                        <button 
                            className="gmf-blog-detail-share-btn gmf-blog-detail-share-fb"
                            onClick={() => handleShare('facebook')}
                            aria-label="Share on Facebook"
                        >
                            <FacebookIcon />
                        </button>
                        <button 
                            className="gmf-blog-detail-share-btn gmf-blog-detail-share-tw"
                            onClick={() => handleShare('twitter')}
                            aria-label="Share on Twitter"
                        >
                            <TwitterIcon />
                        </button>
                        <button 
                            className="gmf-blog-detail-share-btn gmf-blog-detail-share-li"
                            onClick={() => handleShare('linkedin')}
                            aria-label="Share on LinkedIn"
                        >
                            <LinkedInIcon />
                        </button>
                    </div>
                </footer>

                {/* Back Button */}
                <div className="gmf-blog-detail-back">
                    <button 
                        className="gmf-blog-detail-back-btn"
                        onClick={onBack}
                        style={{ background: primaryColor }}
                    >
                        <ArrowLeftIcon /> Back to Home
                    </button>
                </div>

                {/* Related Posts */}
                {relatedPosts.length > 0 && (
                    <section className="gmf-blog-detail-related">
                        <h3 className="gmf-blog-detail-related-title" style={{ color: primaryColor }}>
                            Related Articles
                        </h3>
                        <div className="gmf-blog-detail-related-grid">
                            {relatedPosts.map((relatedPost) => {
                                const relatedImage = relatedPost._embedded?.['wp:featuredmedia']?.[0]?.source_url || '';
                                const relatedDate = formatDate(relatedPost.date);
                                
                                return (
                                    <article 
                                        key={relatedPost.id} 
                                        className="gmf-blog-detail-related-card"
                                        onClick={() => {
                                            // Navigate to related post
                                            window.location.href = `?post_id=${relatedPost.id}`;
                                        }}
                                    >
                                        {relatedImage && (
                                            <div className="gmf-blog-detail-related-image">
                                                <img src={relatedImage} alt="" referrerPolicy="no-referrer" />
                                            </div>
                                        )}
                                        <div className="gmf-blog-detail-related-content">
                                            <span className="gmf-blog-detail-related-date">{relatedDate}</span>
                                            <h4 
                                                className="gmf-blog-detail-related-card-title"
                                                dangerouslySetInnerHTML={{ 
                                                    __html: relatedPost.title?.rendered || 'Untitled' 
                                                }}
                                            />
                                        </div>
                                    </article>
                                );
                            })}
                        </div>
                    </section>
                )}
            </article>
        </div>
    );
};

export default BlogPostDetail;
